module.exports = __webpack_public_path__ + "static/media/notification.883212e6.svg";